/**
 * The UserRole represents all the roles that a user can have in the SolCentre.
 * Add new UserRole as needed.
 */
export enum UserRole {
    Consumer = 'Consumer',
    Provider = 'Provider',
    Commissioner = 'Commissioner'
}